import React from 'react';
import Skeleton from 'core/components/Skeleton';
import clsx from 'clsx';

export function MediaItemSkeleton() {
  return (
    <div className="flex gap-2 border-b p-2 border-b-gray-200 last:border-none">
      <Skeleton className="!h-4 !w-4" />
      <Skeleton className="!h-4 !w-48" />
    </div>
  );
}

type Props = {
  className?: string;
};

export default function MediaListSkeleton({ className }: Props) {
  return (
    <div className={clsx('flex flex-col gap-2', className)}>
      <MediaItemSkeleton />
      <MediaItemSkeleton />
      <MediaItemSkeleton />
    </div>
  );
}
